import { Injectable } from '@angular/core';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';

@Injectable({
  providedIn: 'root',
})
export class CompressionDepartmentService extends SingleDepartmentService {
  readonly DEPARTMENT_ID = 9;
  private _departmentId: number;

  set departmentId(value: number) {
    this._departmentId = value;
  }

  get departmentId(): number {
    return this._departmentId;
  }

  readonly NAME = 'Compression Molding';

  defaultRoutes(roles: string[]): boolean {
    if (roles.includes('RubberCobot')) {
      this.router.navigate(['sb/compression/cobot']);
      return true;
    }

    if (
      roles.includes('Compression') ||
      roles.includes('CompressionScheduler') ||
      roles.includes('CompressionAdmin') ||
      roles.includes('CompressionChief') ||
      roles.includes('CompressionViewer')
    ) {
      this.router.navigate(['sb/compression/scheduling']);
      return true;
    }
    if (roles.includes('CompressionOperator')) {
      this.router.navigate(['sb/compression/scheduler-v2']);
      return true;
    }
    if (roles.includes('CompressionQc')) {
      this.router.navigate(['sb/compression/quality-control']);
      return true;
    }
    if (roles.includes('CompressionLabelOperator')) {
      this.router.navigate(['sb/compression/packing-box']);
      return true;
    }
    return false;
  }
}
